import { render, staticRenderFns } from "./InventoryPayoffControl.vue?vue&type=template&id=b7bb275e&scoped=true"
import script from "./InventoryPayoffControl.vue?vue&type=script&lang=js"
export * from "./InventoryPayoffControl.vue?vue&type=script&lang=js"
import "./InventoryPayoffControl.vue?vue&type=style&index=0&id=b7bb275e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7bb275e",
  null
  
)

export default component.exports